import { render, staticRenderFns } from "./SignUpSelectAuthModal.vue?vue&type=template&id=64c79a06&scoped=true"
import script from "./SignUpSelectAuthModal.vue?vue&type=script&lang=js"
export * from "./SignUpSelectAuthModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpSelectAuthModal.vue?vue&type=style&index=0&id=64c79a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c79a06",
  null
  
)

export default component.exports